var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SubAPI } from "./SubAPI";
var VehiclesAPI = /** @class */ (function (_super) {
    __extends(VehiclesAPI, _super);
    function VehiclesAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VehiclesAPI.prototype.list = function (props) { return this.fetcher.get("/api/vehicles", props); };
    VehiclesAPI.prototype.get = function (id) { return this.fetcher.get("/api/vehicle", { id: id }); };
    VehiclesAPI.prototype.create = function (employee) { return this.fetcher.post("/api/vehicle/create", employee); };
    VehiclesAPI.prototype.update = function (employee) { return this.fetcher.post("/api/vehicle/update", employee); };
    VehiclesAPI.prototype.listForAutoComplete = function () { return this.fetcher.get("/api/vehicles/auto-complete"); };
    VehiclesAPI.prototype.removeRates = function (props) { return this.fetcher.post("/api/vehicle/rate/archive", props); };
    VehiclesAPI.prototype.listRates = function (props) { return this.fetcher.get("/api/vehicle/rates", props); };
    VehiclesAPI.prototype.createRate = function (props) { return this.fetcher.post("/api/vehicle/rate", props); };
    VehiclesAPI.prototype.updateRate = function (props) { return this.fetcher.post("/api/vehicle/rate/update", props); };
    VehiclesAPI.prototype.listFiles = function (input) { return this.fetcher.get("/api/vehicle/files", input); };
    VehiclesAPI.prototype.removeFiles = function (input) { return this.fetcher.post("/api/vehicle/files/bulk-archive", input); };
    VehiclesAPI.prototype.uploadFile = function (input) { return this.fetcher.postFormData("/api/vehicle/file/upload", { info: JSON.stringify(input.info), file: input.file }); };
    return VehiclesAPI;
}(SubAPI));
export { VehiclesAPI };
